import { render, staticRenderFns } from "./catetoryItem.vue?vue&type=template&id=e8ea1f7e&scoped=true"
import script from "./catetoryItem.vue?vue&type=script&lang=js"
export * from "./catetoryItem.vue?vue&type=script&lang=js"
import style0 from "./catetoryItem.vue?vue&type=style&index=0&id=e8ea1f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ea1f7e",
  null
  
)

export default component.exports